import { Phone } from "lucide-react";
import { CRISIS_HELPLINES } from "../data/crisisResources";

const STRIP_HELPLINES = CRISIS_HELPLINES.filter((line) => line.number !== "911");

export default function CrisisResourcesBar() {
    return (
        <div
            data-testid="crisis-resources-bar"
            className="bg-rose-950 text-white border-b border-rose-900/40"
        >
            <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-center gap-3 sm:gap-5 text-[11px] sm:text-xs">
                <span className="inline-flex items-center gap-1.5 font-semibold text-rose-100 shrink-0">
                    <Phone className="w-3 h-3" aria-hidden="true" />
                    In crisis?
                </span>
                {STRIP_HELPLINES.map((line, index) => (
                    <span key={line.tel} className="inline-flex items-center gap-3 sm:gap-5">
                        {index > 0 && (
                            <span className="hidden sm:inline text-white/30" aria-hidden="true">
                                |
                            </span>
                        )}
                        <a
                            href={`tel:${line.tel}`}
                            className="text-white/90 hover:text-white transition-colors whitespace-nowrap"
                        >
                            <span className="font-semibold text-white">{line.number}</span>
                            <span className="hidden md:inline"> — {line.label}</span>
                        </a>
                    </span>
                ))}
            </div>
        </div>
    );
}
